import React from "react";
const Sitemap = () => {
  const sitemapData = {
    mainLinks: [
      { name: "Home", url: "/", description: "Welcome to Asha Modern School" },
      { name: "About", url: "/about", description: "Learn about our school" },
      { name: "Campus", url: "/campus", description: "Explore our campus facilities" },
      { name: "Fee Structure", url: "/fee-structure", description: "View our fee details" },
      { name: "Faculty", url: "/faculty", description: "Meet our dedicated teachers" },
      { name: "Admission", url: "/admission", description: "Join our school family" },
      { name: "Gallery", url: "/gallery", description: "View our photo and video gallery" },
      { name: "News", url: "/news", description: "Latest updates and announcements" },
      { name: "Contact Us", url: "/contact", description: "Get in touch with us" }
    ],
    aboutLinks: [
      { name: "About The School", url: "/about-school", description: "Our history, mission, and vision" },
      { name: "Our Administration", url: "/administration", description: "Meet our leadership team" },
      { name: "Rules & Regulations", url: "/rules-regulations", description: "School policies and guidelines" },
      { name: "Chairman's Message", url: "/chairman-message", description: "Message from our Chairman" },
      { name: "Principal Message", url: "/principal-message", description: "Message from our Principal" }
    ],
    campusLinks: [
      { name: "Campus Overview", url: "/campus", description: "Virtual tour of our campus" },
      { name: "Infrastructure", url: "/infrastructure", description: "Modern facilities and amenities" },
      { name: "Cafeteria", url: "/cafeteria", description: "Healthy and hygienic food" }
    ],
    admissionLinks: [
      { name: "Admission Procedure", url: "/admission-procedure", description: "Step-by-step admission process" },
      { name: "Student Document", url: "/student-documents", description: "Required documents for admission" }
    ],
    galleryLinks: [
      { name: "School Gallery", url: "/school-gallery", description: "Photo gallery of school events" },
      { name: "Video Gallery", url: "/video-gallery", description: "Video highlights and memories" }
    ],
    quickLinks: [
      { name: "Enquiry Form", url: "/enquiry", description: "Submit your queries" },
      { name: "Privacy Policy", url: "/privacy-policy", description: "Our privacy practices" },
      { name: "Terms of Service", url: "/terms-of-service", description: "Terms and conditions" },
      { name: "Sitemap", url: "/sitemap", description: "Website navigation guide" }
    ]
  };
  return (
    <section className="relative py-20 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-red-50 to-pink-50 w-full overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-200/30 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-200/30 rounded-full blur-3xl translate-x-48 translate-y-48"></div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex px-5 py-2 bg-white rounded-full shadow-md mb-4">
            <span className="text-sm font-semibold text-red-600">
              Navigation Guide
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900">
            Website{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Sitemap
            </span>
          </h2>
          <p className="text-gray-600 mt-3 max-w-2xl mx-auto text-sm md:text-base">
            Explore all pages and sections of our website. Find everything you need in one place.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-orange-100 hover:shadow-2xl transition-all duration-500">
            <div className="p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-red-600 to-orange-500 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Main Pages</h3>
              </div>
              <ul className="space-y-2">
                {sitemapData.mainLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.url}
                      className="group flex items-center justify-between p-2 rounded-lg hover:bg-gradient-to-r hover:from-orange-50 hover:to-red-50 transition-all duration-300"
                    >
                      <div>
                        <span className="text-sm font-semibold text-gray-800 group-hover:text-red-600">
                          {link.name}
                        </span>
                        <p className="text-xs text-gray-500 mt-0.5">{link.description}</p>
                      </div>
                      <svg className="w-4 h-4 text-gray-400 group-hover:text-red-500 group-hover:translate-x-1 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                      </svg>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-orange-100 hover:shadow-2xl transition-all duration-500">
            <div className="p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-red-600 to-orange-500 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900">About Us</h3>
              </div>
              <ul className="space-y-2">
                {sitemapData.aboutLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.url}
                      className="group flex items-center justify-between p-2 rounded-lg hover:bg-gradient-to-r hover:from-orange-50 hover:to-red-50 transition-all duration-300"
                    >
                      <div>
                        <span className="text-sm font-semibold text-gray-800 group-hover:text-red-600">
                          {link.name}
                        </span>
                        <p className="text-xs text-gray-500 mt-0.5">{link.description}</p>
                      </div>
                      <svg className="w-4 h-4 text-gray-400 group-hover:text-red-500 group-hover:translate-x-1 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                      </svg>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-orange-100 hover:shadow-2xl transition-all duration-500">
            <div className="p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-red-600 to-orange-500 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Campus</h3>
              </div>
              <ul className="space-y-2">
                {sitemapData.campusLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.url}
                      className="group flex items-center justify-between p-2 rounded-lg hover:bg-gradient-to-r hover:from-orange-50 hover:to-red-50 transition-all duration-300"
                    >
                      <div>
                        <span className="text-sm font-semibold text-gray-800 group-hover:text-red-600">
                          {link.name}
                        </span>
                        <p className="text-xs text-gray-500 mt-0.5">{link.description}</p>
                      </div>
                      <svg className="w-4 h-4 text-gray-400 group-hover:text-red-500 group-hover:translate-x-1 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                      </svg>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-orange-100 hover:shadow-2xl transition-all duration-500">
            <div className="p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-red-600 to-orange-500 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Admission</h3>
              </div>
              <ul className="space-y-2">
                {sitemapData.admissionLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.url}
                      className="group flex items-center justify-between p-2 rounded-lg hover:bg-gradient-to-r hover:from-orange-50 hover:to-red-50 transition-all duration-300"
                    >
                      <div>
                        <span className="text-sm font-semibold text-gray-800 group-hover:text-red-600">
                          {link.name}
                        </span>
                        <p className="text-xs text-gray-500 mt-0.5">{link.description}</p>
                      </div>
                      <svg className="w-4 h-4 text-gray-400 group-hover:text-red-500 group-hover:translate-x-1 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                      </svg>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-orange-100 hover:shadow-2xl transition-all duration-500">
            <div className="p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-red-600 to-orange-500 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Gallery</h3>
              </div>
              <ul className="space-y-2">
                {sitemapData.galleryLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.url}
                      className="group flex items-center justify-between p-2 rounded-lg hover:bg-gradient-to-r hover:from-orange-50 hover:to-red-50 transition-all duration-300"
                    >
                      <div>
                        <span className="text-sm font-semibold text-gray-800 group-hover:text-red-600">
                          {link.name}
                        </span>
                        <p className="text-xs text-gray-500 mt-0.5">{link.description}</p>
                      </div>
                      <svg className="w-4 h-4 text-gray-400 group-hover:text-red-500 group-hover:translate-x-1 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                      </svg>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-orange-100 hover:shadow-2xl transition-all duration-500">
            <div className="p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-red-600 to-orange-500 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Quick Links</h3>
              </div>
              <ul className="space-y-2">
                {sitemapData.quickLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.url}
                      className="group flex items-center justify-between p-2 rounded-lg hover:bg-gradient-to-r hover:from-orange-50 hover:to-red-50 transition-all duration-300"
                    >
                      <div>
                        <span className="text-sm font-semibold text-gray-800 group-hover:text-red-600">
                          {link.name}
                        </span>
                        <p className="text-xs text-gray-500 mt-0.5">{link.description}</p>
                      </div>
                      <svg className="w-4 h-4 text-gray-400 group-hover:text-red-500 group-hover:translate-x-1 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                      </svg>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center">
          <div className="inline-block bg-white rounded-2xl shadow-lg p-6 border border-orange-100">
            <p className="text-gray-600 text-sm">
              <span className="font-bold text-red-600">Total Pages:</span> 25+ pages available
            </p>
            <p className="text-gray-500 text-xs mt-2">
              Last updated: January 2024
            </p>
          </div>
        </div>
        <div className="text-center mt-8">
          <button 
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-orange-500 text-white font-semibold text-sm py-2.5 px-6 rounded-lg hover:shadow-lg hover:scale-105 transition-all duration-300"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Back to Home
          </button>
        </div>
      </div>
    </section>
  );
};

export default Sitemap;